import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private url = environment.url;
  private node_url_v1 = environment.node_url_v1;

  private updateClient_api = 'truein_admin_api.php?method=updateClient';
  private checkSession_Api = 'apis/truein_web_api.php?method=checkSession';
  private freeTrialSignUp_api = 'truein_admin_api.php?method=freeTrialSignUp';
  private empLogin_api = 'truein_web_api.php?method=empLogin';
  private sendOTP_api = 'truein_admin_api.php?method=sendOTP';
  private sendOtp_api = 'auth/sendOtp';
  private verifyClientOTP_api = 'truein_admin_api.php?method=verifyClientOTP';
  private checkEmailMobileExist_api = 'truein_admin_api.php?method=checkEmailMobileExist';
  credentials = {
    office_email: '',
    password: '',
    check_session: ''
  };
  private loginResponseData: any;

  constructor(private http: HttpClient) { }

  getCountryCode() {
    return this.http.get('assets/countries.json');
  }

  checkSession(session) {
    if (environment.login_type === 'local_login') {
      this.credentials.office_email = environment.credentials.office_email;
      this.credentials.password = environment.credentials.password;
      this.credentials.check_session = '1';
    } else {
      this.credentials.check_session = session;
    }
    return this.http.post(this.url + this.checkSession_Api, this.credentials, {
      headers: new HttpHeaders()
        .set('Content-type', 'application/json')
    });
  }

  freeTrialSignUp(credentials) {
    return this.http.post(this.url + this.freeTrialSignUp_api, credentials, {
      headers: new HttpHeaders()
        .set('Content-type', 'application/json')
    });
  }

  updateClient(credentials) {
    return this.http.post(this.url + this.updateClient_api, credentials, {
      headers: new HttpHeaders()
        .set('Content-type', 'application/json')
    });
  }

  empLogin(credentials) {
    return this.http.post(this.url + this.empLogin_api, credentials, {
      headers: new HttpHeaders()
        .set('Content-type', 'application/x-www-form-urlencoded')
    });
  }

  checkEmailMobileExist(credentials) {
    return this.http.post(this.url + this.checkEmailMobileExist_api, credentials, {
      headers: new HttpHeaders()
        .set('Content-type', 'application/json')
    });
  }

  sendOTP(credentials) {
    return this.http.post(this.url + this.sendOTP_api, credentials, {
      headers: new HttpHeaders()
        .set('Content-type', 'application/json')
    });
  }

  sendOtp(credentials) {
    return this.http.post(this.node_url_v1 + this.sendOtp_api, credentials, {
      headers: new HttpHeaders()
        .set('Content-type', 'application/json')
    });
  }

  verifyClientOTP(credentials) {
    return this.http.post(this.url + this.verifyClientOTP_api, credentials, {
      headers: new HttpHeaders()
        .set('Content-type', 'application/json')
    });
  }

  setLoginResponseData(data: any) {
    this.loginResponseData = data;
  }

  getLoginResponseData() {
    const data = this.loginResponseData;
    this.loginResponseData = null;
    return data;
  }
}
